import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { useDispatch } from 'react-redux';
import { AllViewCountActionFetchData } from '../../../redux/actions/AllViewCountAction';
import { FaSearch, FaChevronDown } from 'react-icons/fa';
// import EleLocalImage from '../../../assets/GujaratMapHD.png'
// import GujaratRed from '../../../assets/GujaratRed.mp4';
// import GujaratBlue from '../../../assets/GujaratBlue.mp4';
// import GujaratYellow from '../../../assets/GujaratYellow.mp4';
// import GujaratGreen from '../../../assets/GujaratGreen.mp4';
import BJPLogo from '../../../assets/BJP.png';
import INCLogo from '../../../assets/INC.png';
import OTHLogo from '../../../assets/OTH.png';
import './LocalBodyEle.css';
import axios from 'axios';
import HttpService from '../../../utils/httpService';
import HomeTaboola from '../HomeTaboola';
import PoliticsNewsSection from './PoliticsNewsSection';

const LocalBodyEle = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { activeTier } = location.state || {};

    const [overallData, setOverallData] = useState([]);
    const [jillaPanchayatData, setJillaPanchayatData] = useState([]);
    const [talukaPanchayatData, setTalukaPanchayatData] = useState([]);
    const [nagarPalikaData, setNagarPalikaData] = useState([]);
    const [corporationData, setCorporationData] = useState([]);
    const [selectedTier, setSelectedTier] = useState(null);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [isLocationDropdownOpen, setIsLocationDropdownOpen] = useState(false);
    const locationDropdownRef = useRef(null);
    const [showAllRows, setShowAllRows] = useState(false);
    const [activeCenterTab, setActiveCenterTab] = useState('votes');
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedUnit, setSelectedUnit] = useState(null);
    const resultsRef = useRef(null);
    const tabsScrollRef = useRef(null);

    const scrollToResults = () => {
        resultsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    useEffect(() => {
        // PREVENT BROWSER FROM RESTORING SCROLL POSITION
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        // FORCE TOP IMMEDIATELY
        window.scrollTo(0, 0);

        // DELAYED BACKUP SCROLLS
        const timers = [
            setTimeout(() => window.scrollTo(0, 0), 10),
            setTimeout(() => window.scrollTo(0, 0), 100),
            setTimeout(() => window.scrollTo(0, 0), 500)
        ];

        dispatch(AllViewCountActionFetchData(window.location.pathname));

        const overall = axios.get(`${HttpService.LocalBodyOverAll}`)
        overall.then((res) => {
            const data = res?.data?.data || [];

            // STRICT SORTING: Corporation must be top
            const tierOrder = ['CORPORATION', 'NAGARPALIKA', 'TALUKA PANCHAYAT', 'JILLA PANCHAYAT'];
            const sortedData = [...data].sort((a, b) => {
                const indexA = tierOrder.indexOf(a.NamesEng?.trim().toUpperCase());
                const indexB = tierOrder.indexOf(b.NamesEng?.trim().toUpperCase());
                return (indexA === -1 ? 99 : indexA) - (indexB === -1 ? 99 : indexB);
            });

            setOverallData(sortedData);

            if (sortedData.length > 0) {
                let initialTier = null;
                if (activeTier) {
                    initialTier = sortedData.find(item =>
                        item.NamesEng && item.NamesEng.trim().toUpperCase() === activeTier.trim().toUpperCase()
                    );
                }

                if (!initialTier) {
                    initialTier = sortedData.find(item =>
                        item.NamesEng && item.NamesEng.trim().toUpperCase() === 'CORPORATION'
                    );
                }

                setSelectedTier(initialTier || sortedData[0]);
            }
            console.log(res?.data?.data, "overall.data")
        })
    }, [])

    useEffect(() => {
        if (!selectedTier) return;

        // GOOGLE ANALYTICS: Track tab/tier selection
        const tierSlug = selectedTier.NamesEng?.toLowerCase().trim().replace(/\s+/g, '-');
        ReactGA.send({
            hitType: "pageview",
            page: `${window.location.pathname}/${tierSlug}`,
            title: `Local Body - ${selectedTier.NamesEng}`
        });

        setSelectedDistrict(null);
        setShowAllRows(false);

        if (selectedTier.NamesEng === 'JILLA PANCHAYAT') {
            axios.get(`${HttpService.LocalBodyJillaPanchayat}`).then((res) => {
                setJillaPanchayatData(res?.data?.data || []);
            });
        } else if (selectedTier.NamesEng === 'TALUKA PANCHAYAT') {
            axios.get(`${HttpService.LocalBodyTalukaPanchayat}`).then((res) => {
                const data = res?.data?.data || {};
                setTalukaPanchayatData(data);
                const districts = Object.keys(data);
                if (districts.length > 0) {
                    setSelectedDistrict(districts[0]);
                }
            });
        } else if (selectedTier.NamesEng === 'NAGARPALIKA') {
            axios.get(`${HttpService.LocalBodyNagarPalika}`).then((res) => {
                const data = res?.data?.data || {};
                setNagarPalikaData(data);
                const districts = Object.keys(data);
                if (districts.length > 0) {
                    setSelectedDistrict(districts[0]);
                }
            });
        } else if (selectedTier.NamesEng === 'CORPORATION') {
            axios.get(`${HttpService.LocalBodyCorporation}`).then((res) => {
                const data = res?.data?.data || {};
                setCorporationData(data);
                const corporations = Object.keys(data);
                if (corporations.length > 0) {
                    setSelectedDistrict(corporations[0]);
                }
            });
        }
    }, [selectedTier]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (locationDropdownRef.current && !locationDropdownRef.current.contains(event.target)) {
                setIsLocationDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        setSearchTerm('');
        setShowAllRows(false);
        setIsLocationDropdownOpen(false);

        if (selectedDistrict && tabsScrollRef.current) {
            const container = tabsScrollRef.current;
            const activeTab = container.querySelector('.dist-tab-pill.active');
            if (activeTab) {
                // MANUAL SCROLL: Only moves the container, never the page
                const scrollTarget = activeTab.offsetLeft - (container.offsetWidth / 2) + (activeTab.offsetWidth / 2);
                container.scrollTo({
                    left: scrollTarget,
                    behavior: 'smooth'
                });
            }
        }
    }, [selectedDistrict]);

    const activeTableData = selectedTier?.NamesEng === 'JILLA PANCHAYAT' ? jillaPanchayatData :
        selectedTier?.NamesEng === 'TALUKA PANCHAYAT' ? (talukaPanchayatData[selectedDistrict] || []) :
            selectedTier?.NamesEng === 'NAGARPALIKA' ? (nagarPalikaData[selectedDistrict] || []) :
                selectedTier?.NamesEng === 'CORPORATION' ? (corporationData[selectedDistrict]?.wards || []) : [];

    const filteredData = React.useMemo(() => {
        if (!searchTerm) return activeTableData;
        const lowerSearch = searchTerm.toLowerCase().trim();
        const searchParts = lowerSearch.split(/\s+/);

        return activeTableData.filter(item => {
            const nameEng = (item.NameEng || item.Ward_Name || '').toLowerCase();
            const nameGuj = (item.NameGuj || item.Ward_Name || '').toLowerCase();

            return searchParts.every(part =>
                nameEng.includes(part) || nameGuj.includes(part)
            );
        });
    }, [activeTableData, searchTerm]);

    const totalUnitsCount = React.useMemo(() => {
        if (!selectedTier) return 0;
        if (selectedTier.NamesEng === 'JILLA PANCHAYAT') return jillaPanchayatData.length;

        if (selectedTier.NamesEng === 'TALUKA PANCHAYAT') {
            return Object.values(talukaPanchayatData).reduce((sum, list) => sum + (list?.length || 0), 0);
        }
        if (selectedTier.NamesEng === 'NAGARPALIKA') {
            return Object.values(nagarPalikaData).reduce((sum, list) => sum + (list?.length || 0), 0);
        }
        if (selectedTier.NamesEng === 'CORPORATION') {
            return Object.values(corporationData).reduce((sum, item) => sum + (item.wards?.length || 0), 0);
        }
        return 0;
    }, [selectedTier, jillaPanchayatData, talukaPanchayatData, nagarPalikaData, corporationData]);


    const displayData = selectedTier || {};

    const getProgress = (votes) => {
        if (!votes || typeof votes !== 'string' || !votes.includes('/')) return 0;
        const [done, total] = votes.split('/');
        const pct = (parseInt(done) / parseInt(total)) * 100;
        return isNaN(pct) ? 0 : pct;
    };



    // const getTierVideo = (engName) => {
    //     const videoMap = {
    //         'JILLA PANCHAYAT': GujaratBlue,
    //         'CORPORATION': GujaratRed,
    //         'TALUKA PANCHAYAT': GujaratYellow,
    //         'NAGARPALIKA': GujaratGreen
    //     };
    //     return videoMap[engName] || GujaratRed;
    // };

    return (
        <>
            <div className="local-body-dashboard container">
                <header className="simple-header">
                    <div className="header-content">
                        <div className="title-group">
                            <span className="brand-badge">GUJARAT</span>
                            <h1 className="header-title">
                                <span className="guj-title">ગુજરાત સ્થાનિક સ્વરાજ્ય ચૂંટણી <span className="highlight-2026">2026</span></span>


                            </h1>
                        </div>
                        <div className="header-meta">
                            <div className="live-badge">
                                <span className="pulse-dot"></span>
                                LIVE RESULTS
                            </div>
                            <div className="time-stamp">Updated: Just Now</div>
                        </div>
                    </div>
                </header>

                <div className="ele-dashboard-main-vessel">
                    {/* Top High-Density Grid */}
                    <div className="dashboard-grid">
                        {/* Left: Tiers */}
                        {/* 1. Distributed Tactical Card Stack (Sidebar) */}
                        <div className="tier-panel">
                            <h2 className="panel-label">Local Body Election</h2>
                            <div className="tac-card-stack">
                                {Array.isArray(overallData) && overallData.map((item, index) => (
                                    <div
                                        className={`tac-tier-card cursor-pointer ${selectedTier?.OverAllId === item.OverAllId ? 'active' : ''}`}
                                        key={index}
                                        onClick={() => setSelectedTier(item)}
                                    >
                                        <div className="tac-name-stack">
                                            <h3 className="tac-guj">{item.NamesGuj}</h3>
                                            <h3 className="tac-eng">{item.NamesEng}</h3>
                                        </div>
                                        {selectedTier?.OverAllId === item.OverAllId && (
                                            <div className="tac-active-glow" />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* 2. Unified Tactical Hub (Center) */}
                        <div className="tactical-glass-vault animate-vault-reveal"
                        >
                            <div className="vault-flex-container">
                                {/* Left: Map Execution Stage */}
                                <div className="vault-map-block cursor-pointer" onClick={scrollToResults}>
                                    <div className="stage-digital-grid" />
                                    <div className="map-scanning-laser" />
                                    <div className="map-hud-brackets" />

                                    <video
                                        // src={getTierVideo(selectedTier?.NamesEng)}
                                        autoPlay
                                        loop
                                        muted
                                        playsInline
                                        className="hero-map-tactical animate-map-float"
                                    />

                                    {/* Interactive Progress Ring */}
                                    <div className="stage-hud-ring">
                                        <svg viewBox="0 0 100 100" className="hud-svg">
                                            <circle cx="50" cy="50" r="45" className="ring-base" />
                                            <circle
                                                cx="50" cy="50" r="45"
                                                className="ring-fill"
                                                style={{ strokeDashoffset: 283 - (283 * getProgress(selectedTier?.TotalVotes)) / 100 }}
                                            />
                                        </svg>
                                        <div className="hud-content">
                                            <span className="hud-val">{getProgress(selectedTier?.TotalVotes).toFixed(0)}%</span>
                                            <span className="hud-lbl">RESULTS</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Right: Integrated Tactical Rail */}
                                <div className="vault-stats-rail">
                                    <div className="rail-header">
                                        <div className="r-badge">
                                            <div className="b-dot" />
                                            LIVE TRANSMISSION
                                        </div>
                                        <h2 className="r-guj-name">
                                            {selectedTier?.NamesGuj}
                                            {selectedTier?.NamesEng && <span className="r-eng-bracket">({selectedTier.NamesEng})</span>}
                                        </h2>
                                    </div>

                                    {/* Integrated Totals */}
                                    <div className="rail-summary-stats">
                                        <div className="r-sum-box cursor-pointer" onClick={scrollToResults}>
                                            <span className="r-s-val">{selectedTier?.TotalVotes}</span>
                                            <span className="r-s-lbl">DECLARED</span>
                                        </div>
                                        <div className="r-v-divider" />
                                        <div className="r-sum-box cursor-pointer" onClick={scrollToResults}>
                                            <span className="r-s-val">{totalUnitsCount}</span>
                                            <span className="r-s-lbl">TOTAL {selectedTier?.NamesEng === 'CORPORATION' ? 'WARDS' : 'UNITS'}</span>
                                        </div>
                                    </div>

                                    {/* Live Party Standings (Integrated) */}
                                    <div className="rail-party-standings">
                                        <div className="section-divider">LIVE STANDINGS</div>

                                        <div className="standings-row">
                                            <div className="p-mini-card bjp cursor-pointer" onClick={scrollToResults}>
                                                <div className="p-m-header">
                                                    <div className="p-m-logo">
                                                        <img src={BJPLogo} alt="BJP" />
                                                    </div>
                                                    <div className="p-m-info">
                                                        <span className="p-m-short">BJP</span>
                                                        <span className="p-m-full">Bhartiya Janta Party</span>
                                                    </div>
                                                </div>
                                                <div className="p-m-score">{displayData.BJP || 0}</div>
                                            </div>

                                            <div className="p-mini-card inc cursor-pointer" onClick={scrollToResults}>
                                                <div className="p-m-header">
                                                    <div className="p-m-logo">
                                                        <img src={INCLogo} alt="INC" />
                                                    </div>
                                                    <div className="p-m-info">
                                                        <span className="p-m-short">INC</span>
                                                        <span className="p-m-full">Indian National Congress</span>
                                                    </div>
                                                </div>
                                                <div className="p-m-score">{displayData.CON || 0}</div>
                                            </div>

                                            <div className="p-mini-card oth cursor-pointer" onClick={scrollToResults}>
                                                <div className="p-m-header">
                                                    <div className="p-m-logo">
                                                        <img src={OTHLogo} alt="OTH" />
                                                    </div>
                                                    <div className="p-m-info">
                                                        <span className="p-m-short">OTH</span>
                                                        <span className="p-m-full">OTHERS</span>
                                                    </div>
                                                </div>
                                                <div className="p-m-score">{displayData.OTH || 0}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    {/* Table Section */}
                    <div className="table-header-row" ref={resultsRef}>
                        <h3 className="panel-label">
                            {selectedTier?.NamesGuj || 'Constituency'}
                            {selectedTier?.NamesEng && <span className="label-eng">({selectedTier.NamesEng})</span>}
                            {selectedDistrict && (selectedTier?.NamesEng === 'TALUKA PANCHAYAT' || selectedTier?.NamesEng === 'NAGARPALIKA' || selectedTier?.NamesEng === 'CORPORATION') ? ` — ${selectedDistrict}` : ''}
                        </h3>
                        <div className="table-header-actions">
                            {(selectedTier?.NamesEng === 'TALUKA PANCHAYAT' || selectedTier?.NamesEng === 'NAGARPALIKA' || selectedTier?.NamesEng === 'CORPORATION') && (
                                <div className="dropdown-group" ref={locationDropdownRef}>
                                    <span className="dropdown-hint">Select {selectedTier?.NamesEng === 'CORPORATION' ? 'Corp' : 'Dist'}:</span>
                                    <div className={`custom-glass-dropdown ${isLocationDropdownOpen ? 'open' : ''}`}>
                                        <div
                                            className="dropdown-trigger"
                                            onClick={() => setIsLocationDropdownOpen(!isLocationDropdownOpen)}
                                        >
                                            <span className="trigger-text">{selectedDistrict || 'Select'}</span>
                                            <span className="trigger-icon"><FaChevronDown /></span>
                                        </div>

                                        {isLocationDropdownOpen && (
                                            <div className="dropdown-menu-vessel animate-dropdown">
                                                {Object.keys(
                                                    selectedTier?.NamesEng === 'TALUKA PANCHAYAT' ? talukaPanchayatData :
                                                        selectedTier?.NamesEng === 'NAGARPALIKA' ? nagarPalikaData :
                                                            corporationData
                                                ).map((dist, idx) => (
                                                    <div
                                                        key={idx}
                                                        className={`dropdown-item-option ${selectedDistrict === dist ? 'active' : ''}`}
                                                        onClick={() => {
                                                            setSelectedDistrict(dist);
                                                            setIsLocationDropdownOpen(false);
                                                        }}
                                                    >
                                                        <span className="item-dot" />
                                                        {dist}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {activeTableData.length > 0 && (
                                <div className="table-search-container">
                                    <div className="table-search-box">
                                        <span className="search-icon"><FaSearch /></span>
                                        <input
                                            type="text"
                                            placeholder={`Search ${selectedTier?.NamesEng === 'CORPORATION' ? 'Ward' : 'Location'}...`}
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            className="table-search-input"
                                        />
                                        {searchTerm && (
                                            <button className="search-clear-btn" onClick={() => setSearchTerm('')}>×</button>
                                        )}
                                    </div>
                                </div>
                            )}

                            <div className="table-count-badge">
                                Showing <strong>{filteredData.length}</strong> {selectedTier?.NamesEng === 'CORPORATION' ? 'Wards' : 'Locations'}
                            </div>
                        </div>
                    </div>

                    {/* Tabs for Taluka, NagarPalika, and Corporation */}
                    {(selectedTier?.NamesEng === 'TALUKA PANCHAYAT' || selectedTier?.NamesEng === 'NAGARPALIKA' || selectedTier?.NamesEng === 'CORPORATION') && (
                        <div className="district-tabs-container">
                            <div className="district-tabs-scroll" ref={tabsScrollRef}>
                                {Object.keys(
                                    selectedTier?.NamesEng === 'TALUKA PANCHAYAT' ? talukaPanchayatData :
                                        selectedTier?.NamesEng === 'NAGARPALIKA' ? nagarPalikaData :
                                            corporationData
                                ).map((dist, idx) => (
                                    <button
                                        key={idx}
                                        className={`dist-tab-pill cursor-pointer ${selectedDistrict === dist ? 'active' : ''}`}
                                        onClick={() => {
                                            setSelectedDistrict(dist);
                                        }}
                                    >
                                        {dist}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Corporation Specific Summary Ribbon */}
                    {selectedTier?.NamesEng === 'CORPORATION' && corporationData[selectedDistrict] && (
                        <div className="corp-summary-ribbon">
                            <div className="corp-stat-card total">
                                <div className="corp-icon-box">
                                    {/* <img src={EleLocalImage} alt="Total" className="total-ico" /> */}
                                </div>
                                <div className="corp-info">
                                    <span className="corp-lbl">Declared /Total</span>
                                    <span className="corp-val">{corporationData[selectedDistrict].TotalVotes}</span>
                                </div>
                            </div>
                            <div className="corp-stat-card bjp">
                                <div className="corp-icon-box">
                                    <img src={BJPLogo} alt="BJP" />
                                </div>
                                <div className="corp-info">
                                    <span className="corp-lbl">BJP</span>
                                    <span className="corp-val">{corporationData[selectedDistrict].BJP}</span>
                                </div>
                            </div>
                            <div className="corp-stat-card con">
                                <div className="corp-icon-box">
                                    <img src={INCLogo} alt="INC" />
                                </div>
                                <div className="corp-info">
                                    <span className="corp-lbl">CONG</span>
                                    <span className="corp-val">{corporationData[selectedDistrict].CON}</span>
                                </div>
                            </div>
                            <div className="corp-stat-card oth">
                                <div className="corp-icon-box">
                                    <img src={OTHLogo} alt="OTH" />
                                </div>
                                <div className="corp-info">
                                    <span className="corp-lbl">OTH</span>
                                    <span className="corp-val">{corporationData[selectedDistrict].OTH}</span>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="table-panel">
                        <table className="data-table">
                            <thead>
                                <tr>
                                    <th>{selectedTier?.NamesEng === 'CORPORATION' ? 'WARD' : 'LOCATION'}</th>
                                    <th>TOTAL SEATS</th>
                                    <th>BJP</th>
                                    <th>CONG</th>
                                    <th>OTH</th>
                                    <th>SEATS DECLARED (RESULTS)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(() => {
                                    const finalData = showAllRows ? filteredData : filteredData.slice(0, 10);

                                    return finalData.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="jilla-container">
                                                    <h4 className="j-guj">
                                                        {item.NameEng || item.Ward_Name}</h4>
                                                    {selectedTier?.NamesEng !== 'CORPORATION' && (item.NameGuj || item.Ward_Name) && (
                                                        <h4 className="j-eng">({item.NameGuj || item.Ward_Name})</h4>
                                                    )}
                                                </div>
                                            </td>
                                            <td><div className="total-seats-badge">{item.TotalSeats}</div></td>
                                            <td><div className="party-badge bjp">{item.BJP}</div></td>
                                            <td><div className="party-badge con">{item.CON}</div></td>
                                            <td><div className="party-badge oth">{item.OTH}</div></td>
                                            <td>
                                                <div className="declared-summary">
                                                    <strong>{item.TotalVotes}</strong>
                                                    <div className="progress-mini-bar">
                                                        <div
                                                            className="progress-mini-fill"
                                                            style={{ width: `${getProgress(item.TotalVotes)}%` }}
                                                        ></div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ));
                                })()}
                            </tbody>
                        </table>

                        {Array.isArray(filteredData) && filteredData.length > 10 && (
                            <div className="table-modern-footer">
                                {!showAllRows && <div className="table-ethereal-fade"></div>}
                                <button
                                    className={`view-more-glass-pill cursor-pointer ${showAllRows ? 'active' : ''}`}
                                    onClick={() => setShowAllRows(!showAllRows)}
                                >
                                    <span className="pill-text">
                                        {showAllRows ? 'VIEW LESS' : `VIEW ALL ${filteredData.length} ${selectedTier?.NamesEng === 'CORPORATION' ? 'WARDS' :
                                            selectedTier?.NamesEng === 'JILLA PANCHAYAT' ? 'DISTRICTS' : 'ENTRIES'
                                            }`}
                                    </span>
                                    <span className="pill-icon">{showAllRows ? '▲' : '▼'}</span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>

            </div>

            <PoliticsNewsSection />
            <HomeTaboola />

        </>
    );
};

export default LocalBodyEle;